import type { ChatbotParams, Locale, LocaleConfig } from "@do/shared-types";
import type { MutableRefObject } from "react";
import type { ForDoBotPayload } from "../types/common";

export type LocaleSwitcherParams = {
  availableLocales: NonNullable<ChatbotParams["availableLocales"]>;
  defaultModelLanguage: ChatbotParams["defaultModelLanguage"];
  doBotPayloadRef: MutableRefObject<ForDoBotPayload>;
  doBotUrlRef: MutableRefObject<string | null>;
  requestedLocale?: Locale | null;
  setCurrentLocale: (value: string | ((prevState: string | null) => string | null) | null) => void;
};

export const localeSwitcher = ({
  availableLocales,
  defaultModelLanguage,
  doBotPayloadRef,
  doBotUrlRef,
  requestedLocale,
  setCurrentLocale,
}: LocaleSwitcherParams) => {
  let foundLocale = requestedLocale;
  let foundLocaleCfg: LocaleConfig | null = null;
  // No locale provided, check if a default is provided
  if (!foundLocale) {
    const res = Object.entries(availableLocales).find(([_, localConfig]) => localConfig.isDefault);
    if (!res) return;
    foundLocale = res[0];
  }
  foundLocaleCfg = availableLocales[foundLocale];
  // No config available for the chosen local
  if (!foundLocaleCfg) {
    // eslint-disable-next-line no-console
    console.warn(
      "Locale provided doesn't match any availableLocales:",
      foundLocale,
      availableLocales
    );
    return;
  }
  setCurrentLocale(foundLocale);
  if (foundLocaleCfg.rasaUrl) doBotUrlRef.current = foundLocaleCfg.rasaUrl;
  doBotPayloadRef.current.metadata = doBotPayloadRef.current.metadata || {};
  if (defaultModelLanguage) doBotPayloadRef.current.metadata.modelLanguage = defaultModelLanguage;
  doBotPayloadRef.current.metadata.language = foundLocale;
};
